<template>
    <div id="new_ref_first_step" class="hero flex">
        <div class="hero-body flex_content">
            <div class="container mini-container has-text-centered ">
                <h1 class="title is-size-1 has-text-weight-bold stepTitle" v-if="!notOwnedRef">
                    <span v-if="isNew">{{ $t('modules.refs.formStep1.titleNew') }}</span>
                    <span v-else>{{ $t('modules.refs.formStep1.titleEdit') }}</span>


                </h1>
                <h1 class="title is-size-1 has-text-weight-bold stepTitle" v-else>
                    {{ name }}
                </h1>
                <!-- <input class="big_input" type="text" v-model="name" @input="updateFormData"> -->

                <InputMaterialWrap v-if="!notOwnedRef"
                    v-model="name"
                    label=""
                    class="big_input"
                    validate='required'
                    input-id="refName"
                    @input="updateFormData">
                </InputMaterialWrap>

                <btn-circle-icon
                    v-if="isNew"
                    :class="{disabled: !isFormValid}"
                    class="large"
                    icon="icon-arrow-right"
                    @click.native="nextStep" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormStep1',
    props: ['isNew', "notOwnedRef"],
    data(){
        return {
            ref: this.$store.state.RefStore.newRef,
            steps: this.$store.state.RefStore.steps,
            tabs: this.$store.state.RefStore.tabs
        }
    },
    computed: {
        name: {
            get(){
                return this.$store.state.RefStore.currentRef.name
            },
            set(value){
                this.$store.commit('RefStore/updateRefData', { name: value } )
            }
        },
        isFormValid(){
            return  this.name != ''
        }
    },
    methods: {
        nextStep(){
            if(this.isFormValid){
                this.$store.commit('RefStore/changeCurrentStep', { index: 1 })
            }
        },
        updateFormData(){
            this.$store.commit('RefStore/updateFormValidity', { index: 0, validity: this.isFormValid } )
        }
    }

  }

</script>

<style lang="scss" >
    #new_ref_first_step{
        background: $white;
        .hero-body{
            align-items: center;
            justify-content: center;
        }
    }
</style>